import React from "react";
import Typography from "@mui/material/Typography";
import { Grid } from "@material-ui/core";
import { cmdContCommands, command } from "./../../utility/defined-methods";
import { Button } from "@mui/material";
import Switch from "@mui/material/Switch";
import { useContext, useEffect } from "react";
import { sendCommand } from "../../datastore/actions";
import { useDispatch, useSelector } from "react-redux";
import SocketContext, { socket } from "../../context/create-context";
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
const ColoredLine = (color) => {
  return <hr style={{ height: "2px", width: "80%", backgroundColor: color }} />;
};

const ComCon = () => {
  const { emsName } = useSelector((state) => state);

  const [isInvONOFF, setIsInvONOFF] = React.useState(true);
  const [isEMSSleepAwake, setIsEMSSleepAwake] = React.useState(true);
  const [isMainConOnOff, setIsMainConOnOff] = React.useState(true);
  const [isChargONOFF, setIsChargONOFF] = React.useState(true);
  const [isBalaningONFF, setIsBalancingONOFF] = React.useState(true);
  const dispatch = useDispatch();
  const [success, setSuccess] = React.useState("");
  let commandAndControl = (key, dispatch, client) => {
    switch (key) {
      case 0:
        return (
          <Button
            style={
              { 
                height: "20%",
                width: "20%",
                fontSize: "70%",
              }
            }
            onClick={() => _sendCommand(client, command[0], dispatch, emsName)}
            variant="contained"
          >
            Restart
          </Button>
        );
      case 1:
        return (
          <Button
            style={
              { 
                height: "20%",
                width: "20%",
                fontSize: "70%",
              }
            }
            onClick={() => _sendCommand(client, command[1], dispatch, emsName)}
            variant="contained"
          >
            Reset
          </Button>
        );
      case 2:
        return (
          <Button
            style={
              { 
                height: "20%",
                width: "20%",
                fontSize: "70%",
              }
            }
            onClick={() => _sendCommand(client, command[2], dispatch, emsName)}
            variant="contained"
          >
            Reset
          </Button>
        );
      case 3:
        return (
          <Switch
            checked={isInvONOFF}
            onChange={() => {
              setIsInvONOFF(!isInvONOFF);
              if (isInvONOFF) {
                _sendCommand(client, command[4], dispatch, emsName);
              } else {
                _sendCommand(client, command[3], dispatch, emsName);
              }
            }}
          />
        );

      case 4:
          return (
            <Button
            style={
              { 
                height: "20%",
                width: "20%",
                fontSize: "70%",
              }
            }
            onClick={() => _sendCommand(client, command[5], dispatch, emsName)}
            variant="contained"
          >
            RESET
          </Button>
        );
      case 5:
        return (
          <Switch
            checked={isEMSSleepAwake}
            onChange={() => {
              setIsEMSSleepAwake(!isEMSSleepAwake);
              if (isEMSSleepAwake) {
                _sendCommand(client, command[7], dispatch, emsName);
              } else {
                _sendCommand(client, command[6], dispatch, emsName);
              }
            }}
          />
        );
      case 6:
        return (
          <Switch
            checked={isMainConOnOff}
            onChange={() => {
              setIsMainConOnOff(!isMainConOnOff);
              if (isMainConOnOff) {
                _sendCommand(client, command[8], dispatch, emsName);
              } else {
                _sendCommand(client, command[9], dispatch, emsName);
              }
            }}
          />
        );
      case 7:
        return (
          <Switch
            checked={isChargONOFF}
            onChange={() => {
              setIsChargONOFF(!isChargONOFF);
              if (isChargONOFF) {
                _sendCommand(client, command[10], dispatch, emsName);
              } else {
                _sendCommand(client, command[11], dispatch, emsName);
              }
            }}
          />
        );
      case 8:
        return (
          <Switch
            checked={isBalaningONFF}
            onChange={() => {
              setIsBalancingONOFF(!isBalaningONFF);
              if (isBalaningONFF) {
                _sendCommand(client, command[12], dispatch, emsName);
              } else {
                _sendCommand(client, command[13], dispatch, emsName);
              }
            }}
          />
        );
      case 9:
        return (
          <Button
            style={
              { 
                height: "20%",
                width: "20%",
                fontSize: "70%",
              }
            }
            onClick={() => _sendCommand(client, command[14], dispatch, emsName)}
            variant="contained"
          >
            EEPROM
          </Button>
        );
      case 10:
        return (
          <Button
          style={
              { 
                height: "20%",
                width: "20%",
                fontSize: "70%",
              }
            }
            onClick={() => _sendCommand(client, command[15], dispatch, emsName)}
            variant="contained"
          >
            WKCyclin
          </Button>
        );

      case 11:
        return (
          <Box>
            <TextField style={{
              marginBlockEnd:5
            }}
            id="standard-basic" label="Type Command" variant="standard" />
            <Button
            style={
                { 
                    height: "20%",
                    width: "20%",
                    fontSize: "70%",
                    marginTop: "15px",
                    marginRight: "15px"
                }
              }
              onClick={() => _sendCommand(client, command[15], dispatch, emsName)}
              variant="contained"
              endIcon={<SendIcon />}
            >
            Send
           </Button>
            
          </Box>
          );
        

      default:
        break;
    }
  };
  return (
    <div>
      <table>
        <thead>
        <th style={{
          border: 'solid 1px black',
          padding:'15px',
          color: 'black',
          backgroundColor: '#7AA2E3',
        }} >Commands</th>
        <th>
        <table>
        <thead>
          <tr>
            <th  style={{
              border: 'solid 1px black',
              padding:'10px',
              color: 'black',
              backgroundColor: '#97E7E1',
              }}>
              Command
              </th>
            <th  style={{
              border: 'solid 1px black',
              padding:'10px',
              color: 'black',
              backgroundColor: '#97E7E1',
             
            }}
            >Action</th>
          </tr>
        </thead>
        <tbody>
          {cmdContCommands.map((item, index) => {
            return (
              <tr key={index}>
                <td style={{
                  border: 'solid 1px black',
                  padding:'10px',
                  color: 'black',
                  fontSize: '13px',
                  }}
                >{item}</td>
                <td
                style={{
                  border: 'solid 1px black',
                  padding:'10px',
                  color: 'black',
                  fontSize: '13px',
                 }}
                >{commandAndControl(index, dispatch, socket)}</td>  
              </tr>
            );
          })}
        </tbody>
      </table>    
        </th>
        <th  style={{
          border: 'solid 1px black',
          padding:'20px',
          color: 'black',        
        }}>
          <table>
            <thead>
              <th  style={{
                border: 'solid 1px black',
                padding:'10px',
                color: 'black',
                backgroundColor: '#97E7E1',
               
              }}>
              <Stack spacing={2}>
                  <div>
                    Status
                  </div>
                  <Box
                    height={200}
                    width={200}
                    my={4}
                    display="flex"
                    alignItems="center"
                    gap={4}
                    p={2}
                    sx={{ border: '2px solid grey' }}
                  >
                    Acknowledge from a Pi
                  </Box>
              </Stack>
              </th>
            </thead>
          </table>
        </th>
        </thead>
      </table>
      </div>
    );
};

let _sendCommand = (client, _command, dispatch, emsID) => {
  let data = {
    command: _command,
    emsID: emsID,
  };
  console.log("CommandData", data);
  dispatch(sendCommand(client, data));
};

export default ComCon;
